import React, { FunctionComponent } from 'react';

import clsx from 'clsx';

import { isValueSet } from '@utils/guards';
import { applyTypograf } from '@utils/typograf';

import { Container } from '@components/common/Container/Container';
import { Link } from '@components/common/Link/Link';
import { LinkArrowIcon } from '@components/icons';

import styles from './SliderBlockTitle.module.scss';

type ClassKey = 'root' | 'container' | 'title' | 'link';

type SliderBlockTitleProps = {
    title: string;
    link?: string;
    linkText?: string;
    isOpenLinkInNewTab?: boolean;
    classes?: Classes<ClassKey>;
};
export const SliderBlockTitle: FunctionComponent<SliderBlockTitleProps> = (props) => {
    const { title, link, classes, linkText = 'Смотреть все', isOpenLinkInNewTab = false } = props;

    return (
        <div className={clsx(styles.root, classes?.root)}>
            <Container classes={{ root: clsx(styles.container, classes?.container) }}>
                <h2 className={clsx(styles.title, classes?.title)}>{applyTypograf(title)}</h2>
                {isValueSet(link) && isValueSet(linkText) && (
                    <Link
                        route={link}
                        target={isOpenLinkInNewTab ? '_blank' : '_self'}
                        className={clsx(styles.link, classes?.link)}
                    >
                        <span>{linkText}</span>
                        <LinkArrowIcon className={styles.icon} />
                    </Link>
                )}
            </Container>
        </div>
    );
};
